import { parser } from 'lezer-r';
import { LRLanguage, indentNodeProp, delimitedIndent, foldNodeProp, foldInside, LanguageSupport } from '@codemirror/language';

const rLanguage = /*@__PURE__*/LRLanguage.define({
    parser: /*@__PURE__*/parser.configure({
        props: [
            /*@__PURE__*/indentNodeProp.add({
                Block: /*@__PURE__*/delimitedIndent({ closing: "}" }),
                "ParamList ArgList": /*@__PURE__*/delimitedIndent({ closing: ")" }),
            }),
            /*@__PURE__*/foldNodeProp.add({ Block: foldInside }),
        ],
    }),
    languageData: {
        closeBrackets: { brackets: ["(", "[", "{", "'", '"'] },
        commentTokens: { line: "#" },
    },
});
function r() {
    return new LanguageSupport(rLanguage);
}

export { r, rLanguage };
